// extracted by mini-css-extract-plugin
export default {"menu":"MenuPart_menu__xAGn-"};